const { Dashboard } = require('./Locale/en.js');

module.exports = {
    // default (green), red, yellow, blue
    colorSchema: 'green',
    urlPath: '/app/',
    appClass: 'flemming',
    footer: require('./footer.html'),
    pageTitle: 'Flemming Tec',
    sideMenu: require('./Sidemenu.js'),
    logo: '/img/logo.png',
    termsUrl: 'https://www.flemming-tec.de/agb',
    allowDeliveryPrint: true,
    defaultView: 'Packages',
    orderStatusCodes: {
      "notstarted": "In Vorbereitung",
      "cam": "CAM / Nesting",
      "milling": "In Fertigung",
      "complete": "Fertigung abgeschlossen"
    },
    finderColumnsCount: 4,
    workflowTypes: {
      Manufacturing: require('./Manufacturing/Manufacturing.js'),
      Import: require('./Manufacturing/Manufacturing-Import.js'),
      Construction: require('./Construction/Construction.js'),
      // Implant: require('./Implant/Implant.js'),
      Approval: require('./Approval/Approval.js'),
      External: require('./External/External.js'),
      // Aligner: require('./Aligner/Aligner.js'),
    },
    help: [
      {'//': '...'}
    ],
    projectColumns: [
      'name',
      'creationdate',
      'lastmodified',
      'workflow',
      'status'
    ],
    orderColumns: [
      'transactionnum',
      'reference',
      'workflow',
      'date',
      'amount',
      'status',
    ],
    workflowGroups: {
      Manufacturing: {
        title: {
          de: 'Fertigung',
          en: 'Manufacturing'
        },
        description: 'Sie haben bereits fertige STL-Fertigungsdaten und benötigen einen verlässlichen Partner für die Fertigung Ihres Produkts.',
        image: '/img/crown.jpg',
        show: false
      },
      Construction: {
        title: {
          de: 'Konstruktion',
          en: 'Construction'
        },
        description: 'Sie haben ein digitales oder physisches Modell und benötigen einen Partner für die Planung, Konstruktion und Fertigung?',
        image: '/img/icon_construction.png',
        show: false
      },
      /*
      Implant: {
        title: {
          de: 'Implantatplanung',
          en: 'Implant planning'
        },
        description: 'Sie möchten eine Restauration auf Basis von Implantaten planen? Gerne unterstützen wir sie dabei!',
        image: '/img/crownabutment.jpg',
        show: false
      },
      Aligner: {
        title: {
          de: 'Aligner',
          en: 'Aligner'
        },
        description: 'Sie möchten eine Alignertherapie planen? Gerne unterstützen wir sie dabei!',
        image: '/img/icon_implant.png',
        show: false
      },
      */
    },
    loginIntro: {
      de: 'Bitte melden Sie sich mit ihrem Flemming Tec Zugang an.',
      en: 'Please login using your Flemming Tec account.'
    },
    loginOutro: {
      de: '<b>Kein Zugang?</b> <a href="https://app.flemming.com/register/">Hier können Sie sich registrieren!</a><br/><b>Passwort vergessen?</b> <a href="/app/login/reset">Hier können Sie Ihr Passwort zurücksetzen!</a>',
      en: '<b>No account?</b> <a href="https://app.flemming.com/register/">You can register here!</a><br/><b>Forgot your password?</b> <a href="/app/login/reset">Reset your password here!</a>'
    },
    hintNewProject: {
      de: 'Bitte keine Patientendaten angeben',
      en: 'Please do not include any patient-ralated information'
    },
    disableInvoiceList: false,
    disableAddressEdit: false,
    disableAddressSelect: false,
    disablePasswordChange: false,
    // localesOff: {
    //   de: require('./Locale/de.js'),
    //   en: require('./Locale/en.js')
    // },
    locales: {
      de: {
        Dashboard: {
          title: 'Dashboard',
          NewConstruction: 'Neue Konstruktion anlegen',
          NewProduction: 'Neue Fertigung',
          CreateNewCase: 'Neuen Fall erstellen',
          ConstructionDescription: 'Sie möchten uns mit einer Konstruktion beauftragen, die wir nach Ihrer Freigabe in unserem modernen Fertigungszentrum produzieren? Dann starten Sie hier!',
          ManufactureDescription: 'Sie haben bereits fertige CAD Daten und möchten Ihre Produkte in unserem modernen Fertigungszentrum herstellen lassen? Dann starten Sie hier!'
        }
      },
      en: {
        Dashboard: {
          title: 'Dashboard',
          NewConstruction: 'New Construction',
          NewProduction: 'New Production',
          CreateNewCase: 'Create new case/project',
          ConstructionDescription: 'You want us to construct your order and subsequently produce it in our milling center following your approval? Then start here!',
          ManufactureDescription: 'Do you already have finished CAD data and would like to have your products manufactured in our modern production center? Then start here!'
        }
      }
    }
}
